import {
  hasPermission,
  hasSogetiPermission,
  rbacElements
} from "../_helpers/rbac";

export default {
  data: () => ({ rbacElements }),
  methods: {
    hasPermission(allowedRoles: string[]): boolean {
      return hasPermission(allowedRoles);
    },
    hasSogetiPermission(allowedRoles: string[]): boolean {
      return hasSogetiPermission(allowedRoles);
    }
  }
};
